<style>
.ivu-vueSelected {
  width: 100%;
  height: 100%;
}
.ivu-select-small.ivu-select-single .ivu-select-selection {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.ivu-select-small.ivu-select-single .ivu-select-selection div {
  height: 100%;
}
.ivu-select-small.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
}
.ivu-vueSelected-div {
  width: 100%;
  height: 100%;
  position: absolute;
  padding: 0;
}
.ivu-vueSelected-div .ivu-select{
  display: block;
}
</style>

<template>
  <div class="ivu-vueSelected-div" v-if="isShow" :style="selectedStyle">
    <Select
      :style="selectedStyle"
      :label-in-value="true" 
      v-model="selectedString"
      filterable
      clearablea
      class="ivu-vueSelected"
      :transfer="true"
      @on-change="getIndex"
      @on-open-change="getOldValue"
      size="small"
    >
      <Option
        v-for="(primitives, index) in optionData"
        :value="primitives.value"
        :key="index"
        >{{ primitives.label }}</Option
      >
    </Select>
    <div v-if="isEnable" :style="enableStyle"></div>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  name: "fvSelected",
  props: ["primitives", "fvSystemApi", "parentObject"],
  data() {
    return {
      isShow: true,
      isEnable: false,
      selected: "",
      selectedStyle: "",
      selectedString: "", // 下拉框选中数据
      optionData: [], // 下拉列表数据
      sourceOptionData: [],
    };
  },
  created() {
    this.defaultTailoring = this.parentObject.defaultTailoring;
    this.windowSize = this.parentObject.windowSize;
    this.create();
    this.modelsPath = this.parentObject.modelsPath.slice(0);
    this.modelsPath.push(this.registerName);
    this.$store.registerModule(this.modelsPath, {
      state: {
        $: this,
      },
    });
  },
  methods: {
    create() {
      this.mixin(this.primitives);
      //this.option = this.resolveData(this.option);
      this.sourceOptionData = this.option ? this.option : [];
      this.optionData = [];
      for (var i = 0; i < this.sourceOptionData.length; i++) {
        var node = {
          label: this.sourceOptionData[i].label,
          value: this.sourceOptionData[i].label ? i : "",
        };
        this.sourceOptionData[i].value = i;
        if (this.sourceOptionData[i].selected != undefined) {
          node.selected = this.sourceOptionData[i].selected;
        }
        var tempText = this.fvSystemApi.getResource(node.label);
        if (tempText) {
          node.label = node.value = tempText;
        }
        this.optionData.push(node);
      }

      //初始化位置
      this.selectedStyle = {
        left: 0 + "px",
        top: 0 + "px",
        width: 0 + "px",
        height: 0 + "px",
      };
      this.enableStyle = {
        position: "absolute",
        width: "100%",
        height: "100%",
        top: "0px",
        backgroundColor: "#ccbfbf",
        opacity: "0.5",
      };

      if (this.sourceOptionData.length != 0 && this.sourceOptionData) {
        if (this.sourceOptionData[this.selected]) {
          this.selectedString =
            this.fvSystemApi.getResource(this.sourceOptionData[this.selected].value) ||
            this.sourceOptionData[this.selected].value;
        } else {
          this.selectedString =
            this.fvSystemApi.getResource(this.sourceOptionData[0].value) ||
            this.sourceOptionData[0].value;
        }
      } else {
        this.optionData = [];
        this.selectedString = "";
      }
      try {
        if (this.onChange && this.onChange != "%onChange%") {
          this.onChange = AsyncFunction("oldStr", "newStr", this.onChange);
        }
      } catch (e) {
        console.log(e + "脚本保存错误");
      }
    },
    //混入属性
    mixin(src) {
      for (var key in src) {
        this[key] = src[key];
      }
    },
    /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
    doFixedEvent(e, domScale) {},
    reDraw(scaleObj) {
        this.scaleObj = scaleObj;
        if(scaleObj.titleHeight != 0){
            var titleHeight = 0;
        }else{
            var titleHeight = this.y * this.frameScaleY;
        }
        let top = parseFloat(((this.y + titleHeight)* (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy)
        this.selectedStyle.left = parseInt(((this.x)* (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
        this.selectedStyle.top =top - titleHeight  + "px";
      
        this.selectedStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
        if (parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) < 18) {
        this.selectedStyle.height = 18 + "px";
        } else {
        this.selectedStyle.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
        }
        //重绘高度 来设置文本居中
        setTimeout(() =>{
            this.$el.children[0].children[0].children[1].children[1].style.height = parseFloat(this.selectedStyle.height) - 4 + "px";
        },20);
        
    },

    onTimer() {
      if (this.isEnable) return;
    },

    /*
            参数：无
            作用：获取元素在数组中的坐标，执行控件onchange事件
        */
    getIndex(val) {
      if(val==undefined) return;
      this.selectedString = val.value;
      this.selected = val.value;
      this.RegEvent_onChange(this.oldSelected, val.label);
    },

    /*
            参数： flag true 展开前，false 闭合后
            作用：获取切换数据前的值
        */
    getOldValue(flag) {
      if (flag) {
        this.oldSelected = this.selectedString;
      }
    },

    /*
            参数：字段名称
            作用：想下拉框列表中添加字段
        */
    AddString(str) {
      if (str == "" || str == undefined) {
        this.$Message.error(
          this.$store.state.system.$.languageName == "ch"
            ? "当前节点为空,添加失败且返回值无效！"
            : "Current node is empty, add failed and return value is invalid!"
        );
        return "";
      }
      this.optionData.push({
        label: str,
        value: this.optionData.length + 1,
      });
      return this.optionData.length - 1;
      //this.selectedString = this.optionData[this.selected].label;
      //this.optionData = this.resolveData(this.optionData);
      // for(var i = 0 ; i < this.optionData.length ; i++){
      //     if(this.optionData[i].label == str){
      //         return parseInt(i);
      //     }
      // }
    },

    /*
            参数：无
            作用：获取当前显示的字符串的ID
        */
    GetID() {
      return this.selected;
    },

    /*
            参数：无
            作用：获取当前显示的字符串
        */
    GetString() {
      let index = this.selectedString;
      if (index !== undefined) {
        return this.optionData[index].label || this.sourceOptionData[index].label;
      } else {
        for (let i = 0; i < this.optionData.length; i++) {
          if (i !== this.optionData[i].value) {
            this.optionData[i].value = i;
            this.selectedString = i;
          }
        }

        for (let j = 0; j < this.sourceOptionData.length; j++) {
          if (j !== this.sourceOptionData[j].value) {
            this.sourceOptionData[j].value = j;
            this.selectedString = j;
          }
        }

        return (
          this.optionData[this.selectedString].label ||
          this.sourceOptionData[this.selectedString].label
        );
      }
    },

    /*
            参数：数组下标
            作用：需要删除的字符串的索引,-1为删除所有，
        */
    RemoveString(index) {
      this.selectedString = "";
      if (index == -1) {
        // this.optionData.splice(0,this.optionData.length);//清空数组
        this.optionData.length = 0;
      } else {
        this.sourceOptionData.splice(index, 1);
        this.optionData.splice(index, 1);
        for (let i = 0; i < this.optionData.length; i++) {
          if (i !== this.optionData[i].value) {
            this.optionData[i].value = i;
            this.selectedString = i;
          }
        }
        for (let j = 0; j < this.sourceOptionData.length; j++) {
          if (j !== this.sourceOptionData[j].value) {
            this.sourceOptionData[j].value = j;
            this.selectedString = j;
          }
        }
      }
      this.selectedString = "";
      this.reDraw(this.scaleObj);
    },

    /*
            参数：数据改变前坐标，现坐标
            作用：控件onchange事件方法
        */
    RegEvent_onChange(oldStr, newStr) {
      if (typeof this.onChange == "function") {
        this.fvSystemApi.executionScript(this.onChange, oldStr, newStr);
      }
    },

    /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
    Show(isShow) {
      this.isShow = isShow ? true : false;
    },

    /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
    Enable(isEnable) {
      this.isEnable = isEnable ? false : true;
    },

    /*
            参数：data 下拉框内容
            作用： 去除下拉框中key值相同的数据
        */
    resolveData(data) {
      if (data == undefined) {
        return [];
      } else {
        const res = new Map();
        return data.filter((a) => !res.has(a.value) && res.set(a.value, 1));
      }
    },
  },
  mounted() {
    // setTimeout(() => {
    //     this.selectedString = "删除"
    // }, 50000)
  },
};
</script>



// WEBPACK FOOTER //
// src/components/primitives/fvSelected/fvSelected.vue